<template>
  <div>
    <input type="range" v-model="numOfIteration" max="10" />
    <input type="range" v-model="angle" max="90" />
    <p>testData: {{ testData }}</p>
    <svg :width="width" :height="height">
      <g id="stem">
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="-1"
          stroke="black"
          :stroke-width="0.1"
        ></line>
      </g>
      <g id="l0">
        <use href="#stem"></use>
      </g>

      <g v-for="(href, id) in leaves" v-bind:key="id" :id="id">
        <use :href="href" :transform="translationL"></use>
        <use :href="href" :transform="translationR"></use>
        <use xlink:href="#stem"></use>
      </g>
      <g :transform="finalLeaf['transFinal']">
        <use :href="finalLeaf['hrefFinal']"></use>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "FractalTree",
  data() {
    return {
      width: 400,
      height: 320,
      numOfIteration: 9,
      angle: 15,
      scale: 0.7,
      testData: [1, 2, 3].map(i => i + 1)
    };
  },
  computed: {
    translationL: function() {
      return (
        "translate(0, -1) rotate(-" + this.angle + ") scale(" + this.scale + ")"
      );
    },
    translationR: function() {
      return (
        "translate(0, -1) rotate(+" + this.angle + ") scale(" + this.scale + ")"
      );
    },
    leaves: function() {
      var res = {};
      for (var i = 0; i < this.numOfIteration; i++) {
        var id = "l" + (i + 1);
        res[id] = "#l" + i;
      }
      return res;
    },
    finalLeaf: function() {
      return {
        transFinal:
          "translate(" + this.width / 2 + ", " + this.height + ") scale(100)",
        hrefFinal: "#l" + this.numOfIteration
      };
    }
  }
};
</script>

<style></style>
